const _temp0 = require("../_shared/tag/toaster.view.js");
const _temp1 = require("../_shared/tag/toaster.view.less");
module.exports = {
  "js": _temp0,
  "less": _temp1
}